import Modal from "../../modal/Modal";

const StopLossConfirmModal = ({ isOpen, onClose, isPending, onConfirm }) => (
    <Modal isOpen={isOpen} onClose={onClose}>
        <div className="stoploss-confirm-modal">
            <p className="stoploss-confirm-modal__heading">Run the Stop Loss report now?</p>
            <p className="stoploss-confirm-modal__body">
                This emails the report to the same recipients as the nightly run.
                It can't be cancelled once started, and you won't be able to run
                it again for 10 minutes afterward.
            </p>
            <div className="stoploss-selfservice-modal__actions">
                <button className="finance-ops__link-btn" onClick={onClose}>
                    Cancel
                </button>
                <button
                    className="finance-ops__primary-btn"
                    disabled={isPending}
                    onClick={onConfirm}
                >
                    {isPending ? "Starting…" : "Run report"}
                </button>
            </div>
        </div>
    </Modal>
);

export default StopLossConfirmModal;
